import { useState, React } from "react";
import { Button, Form } from "react-bootstrap";
import DomandaSondaggio from "./DomandaSondaggio";
import { IoMdAdd } from "react-icons/io"; //import icons for add
import { GoTrash } from "react-icons/go"; //import icons for trash
import { BiCopy } from "react-icons/bi"; //Import icons for copy
import { FaChevronUp, FaChevronDown } from "react-icons/fa"; // Import icons for collapse/expand
import { Droppable, Draggable } from 'react-beautiful-dnd';
import './Sondaggi.css';


export default function SezioneSondaggio({
  sezione,
  index,
  id, // per scrollare alla sezione quando viene duplicata
  aggiornaSezione,
  mandatoryField,
  aggiungiDomanda, // Prop from parent to add a question *to this section*
  eliminaDomanda, // Prop from parent to delete a question *from this section*
  modificaDomanda,
  muoviDomanda, // Prop from parent to move question *within this section*
  spostaDomandaTraSezioni,
  validato,
  errori,
  punteggioAttivo,
  tutteLeDomande, // All questions from all sections
  spostaDomanda,
  mostraIntestazione = true,
  tutteLeSezioni, // All sections
  erroriDomande, // Errors specific to questions in this section
  handleDeleteSezione, // Prop from parent to delete *this section*
  setDomandaCompleta,
  duplicaSezione,
  onOptionFieldChange,
  clearErroreDomanda,
  sezioneIndex
  
}) {
  const [isCollapsed, setIsCollapsed] = useState(false); // State for collapse/expand

  const handleNomeChange = (e) => {
    aggiornaSezione(index, { ...sezione, sezNome: e.target.value });
  };

  const handleAggiungiDomanda = () => {
    aggiungiDomanda(index);
  };

  return (
    <div className="sezione-wrapper mb-4" id={id} >
      <div className="sezione-wrapper mb-4">
        {mostraIntestazione && (
          <div className="d-flex align-items-center w-100" style={{ gap: '0.5rem' }}>
            <h5
              className="mb-0 me-2 flex-shrink-0 align-self-center"
              style={{ fontSize: '1.25rem', lineHeight: 1, fontWeight: 'bold' }}
            >
              Sezione {sezione.sezPosizione}:
            </h5>
            <Form.Control
              type="text"
              placeholder="Titolo sezione"
              value={sezione.sezNome}
              onChange={handleNomeChange}
              className="flex-grow-1"
              style={{ minWidth: '120px' }}
            />
            {/* Bottone duplica sezione */}
            <Button
              variant="secondary"
              className="text-white mb-0 me-2 flex-shrink-0 d-flex justify-content-center align-items-center"
              style={{ width: '40px', height: '40px' }}
              onClick={() => duplicaSezione(sezione)}
              title="Duplica sezione"
            >
              <BiCopy color="white" />
            </Button>
            {/* Collapse/Expand Button */}
            <Button
              variant="outline-secondary" 
              className="text-secondary mb-0 me-2 flex-shrink-0 d-flex justify-content-center align-items-center collapse-toggle-btn" // Use text-secondary for icon color
              style={{ width: '40px', height: '40px' }}
              onClick={() => setIsCollapsed(!isCollapsed)}
              title={isCollapsed ? "Espandi sezione" : "Riduci sezione"}
            >
              {isCollapsed ? <FaChevronDown /> : <FaChevronUp />}
            </Button>
            {/* Delete Button */}
            <Button
              variant="danger"
              className="text-white mb-0 me-2 flex-shrink-0 d-flex justify-content-center align-items-center"
              style={{ width: '40px', height: '40px' }}
              onClick={() => handleDeleteSezione(sezione)}
              title="Elimina sezione"
            >
              <GoTrash className="fs-3" />
            </Button>
          </div>
        )}
      </div>
      {/* Conditionally render content based on isCollapsed state */}
      {!isCollapsed ? (
        <>
          <div className="ps-3 border-start border-3 border-primary">
            <Droppable droppableId={`sezione-${sezione.sezPosizione}`}>

              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {sezione.domande.map((domanda, domIndex) => (
                    <Draggable
                      key={domanda.domId || `${index}-${domIndex}`}
                      draggableId={`domanda-${domanda.domId || `${index}-${domIndex}`}`}
                      index={domIndex}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          style={{
                            ...provided.draggableProps.style,
                            marginBottom: "1rem",
                            opacity: snapshot.isDragging ? 0.8 : 1,
                          }}
                        >
                          <DomandaSondaggio
                            key={domanda.domId || `${index}-${domIndex}`}
                            index={domIndex}
                            domanda={domanda}
                            sezioneIndex={sezioneIndex}
                            validato={validato}
                            clearErroreDomanda={clearErroreDomanda}
                            setDomandaCompleta={setDomandaCompleta}
                            erroriDomande={erroriDomande?.[domIndex]}
                            mandatoryField={mandatoryField}
                            sezioni={tutteLeSezioni}
                            dragHandleProps={provided.dragHandleProps}
                            sezioneCorrentePosizione={sezione.sezPosizione}
                            setDomandaField={(field, value) => {
                              modificaDomanda(index, domIndex, field, value);
                          }}
                            handleDeleteDomanda={() => eliminaDomanda(index, domIndex)}
                            modificaOpzione={(opzIdx, campo, val) => {
                              onOptionFieldChange(index, domIndex, opzIdx, campo, val);
                          }}
                            aggiungiOpzione={() => {
                              const nuoveDomande = [...sezione.domande];
                              nuoveDomande[domIndex].opzioniRisposta = [
                                ...(nuoveDomande[domIndex].opzioniRisposta || []),
                                {
                                  opzRisTesto: "",
                                  opzRisPunteggio: null,
                                  opzRisPosizione: (nuoveDomande[domIndex].opzioniRisposta?.length || 0) + 1,
                                  opzRisSezSuccessiva: null,
                                  opzRisFlTermina: false
                                }
                              ];
                              aggiornaSezione(index, { ...sezione, domande: nuoveDomande });
                            }}
                            eliminaOpzione={(secIdx, opzIdx) => {
                              const nuoveDomande = [...sezione.domande];
                              nuoveDomande[domIndex].opzioniRisposta = nuoveDomande[domIndex].opzioniRisposta.filter((_, i) => i !== opzIdx);
                              aggiornaSezione(index, { ...sezione, domande: nuoveDomande });
                            }}
                            punteggioAttivo={punteggioAttivo}
                            domande={tutteLeDomande}
                            muoviDomanda={(idx, direzione) => muoviDomanda(index, idx, direzione)}
                            spostaDomanda={(fromSecIdx, toSecIdx, domandaIdx) => spostaDomanda(index, fromSecIdx, toSecIdx, domandaIdx)}
                            duplicaDomanda={(domIndex) => {
                              const nuovaDomanda = {
                                ...sezione.domande[domIndex],
                                domId: null, // resetta ID
                                domNumPosizione: domIndex + 2, // sarà posizionata dopo
                                opzioniRisposta: sezione.domande[domIndex].opzioniRisposta.map(opz => ({
                                  ...opz,
                                  opzRisId: null
                                }))
                              };

                              const nuoveDomande = [...sezione.domande];
                              nuoveDomande.splice(domIndex + 1, 0, nuovaDomanda);

                              // Riassegna le posizioni
                              nuoveDomande.forEach((d, i) => {
                                d.domNumPosizione = i + 1;
                              });

                              aggiornaSezione(index, { ...sezione, domande: nuoveDomande });
                            }}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>

          </div>
          {/* Add Question Button */}
          <div className="mt-3 text-center">
            <Button variant="outline-primary" size="sm" onClick={handleAggiungiDomanda}>
              Aggiungi Domanda a Sezione {sezione.sezPosizione} <IoMdAdd />
            </Button>
          </div>
        </>
      ) : (
        // Collapsed View
        <div className="mt-2 ps-3 text-muted border-start border-3 border-secondary">
          {sezione.domande.length > 0 ? (
            sezione.domande.map((domanda, domIndex) => (
              <p key={domanda.domId || `dom-${index}-${domIndex}-collapsed`} className="mb-1 ps-2">
                <small><em>{domIndex + 1}. {domanda.domDomanda || "(Domanda senza testo)"}</em></small>
              </p>
            ))
          ) : (
            <p className="mb-1 ps-2"><small><em>(Nessuna domanda in questa sezione)</em></small></p>
          )}
        </div>
      )}
    </div>
  );
}
